document.addEventListener('DOMContentLoaded', function() {
  // Early exit if gifting markup does not exist (e.g., Quick Shop)
  if (!document.getElementById('confirm-gifting')) {
    return;
  }

  class GiftingDrawer extends HTMLElement {
    constructor() {
      super()

      this.setEventListeners()
    }

    setEventListeners() {
      const drawerOverlay = this.querySelector('#GiftingDrawer-Overlay')
      const giftButton = document.querySelector('.perfect-gift-btn')
      const giftDrawer = this.querySelector('#gifting-drawer')
      const giftBoxCheckboxes = this.querySelectorAll('.gift-box-checkbox')
      const giftCounter = this.querySelector('#textarea_feedback')
      const giftTextarea = this.querySelector('#gift-message')

      const variantPriceGiftBox = document.querySelector('#variantPrice-gift-box')
      const giftBoxPrice = document.querySelector('#gift-box-price')
      const selectedGiftBox = document.querySelector('#selected-gift-box')
      const giftBoxVariantIdField = document.querySelector('#gift-box-variant-id')
      const giftBoxGiftPid = document.querySelector('#gift__variantId')
      const giftBoxWithProduct = document.querySelector('#gift-box-for-product')
      const giftBoxProductHandle = document.querySelector(
        '#gift-box-product-handle'
      )
      const giftBoxProductHandleItem = document.querySelector(
        '#gift-box-product-handle-item'
      )

      const closeGiftingBtn = this.querySelector('#close-gifting')
      if (closeGiftingBtn) {
        closeGiftingBtn.addEventListener('click', () => {
          this.closeDrawer()
        })
      } else {
        console.warn('[GiftBox Debug] close-gifting button not found');
      }

      if (giftButton) {
        giftButton.addEventListener('click', () => {
          this.openDrawer()
          // Prime hidden inputs based on the default-checked gift (if any)
          this.primeGiftDefaults()
        })
      } else {
        console.warn('[GiftBox Debug] gift button not found - .perfect-gift-btn element missing');
      }

      if (giftTextarea) {
        giftTextarea.addEventListener('input', event => {
          this.checkTextLength(event.target)
        })
      } else {
        console.warn('[GiftBox Debug] giftTextarea element not found - #gift-message element missing');
      }

      const giftBoxPriceSpan = document.getElementById('gift-box-price-tag')
      const giftDrawerMessage = document.getElementById('gift-message')

      if (giftBoxCheckboxes && giftBoxPriceSpan && giftDrawerMessage) {
        giftBoxCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('click', function () {
            giftBoxVariantIdField.value = checkbox.value
            giftBoxGiftPid.value = checkbox.value
            // The "Gift Box With" property should reference the MAIN product
            // title (inc. variant) rather than the gift-box title. Try to grab
            // it from the PDP heading; if not found fall back to variant title
            // text.
            const mainTitleEl = document.querySelector('[data-product-title]') || document.querySelector('.product__title')
            const mainTitle = mainTitleEl ? mainTitleEl.textContent.trim() : checkbox.dataset.parentProductTitle || document.title
            giftBoxWithProduct.value = mainTitle
            giftBoxProductHandle.value = checkbox.dataset.productHandle
            giftBoxPrice.innerHTML = checkbox.dataset.productPrice
            selectedGiftBox.innerHTML = checkbox.dataset.productTitle
            giftBoxProductHandleItem.value = checkbox.dataset.productHandle
            giftBoxPriceSpan.style.display = 'inline'
            giftDrawerMessage.focus()
          })
          checkbox.addEventListener("change", function () {
            giftDrawerMessage.disabled = !this.checked
          })
        })
      }

      if (drawerOverlay && giftDrawer) {
        drawerOverlay.addEventListener('click', () => {
          this.closeDrawer()
        })
      }

      const confirmGiftingBtn = document.getElementById('confirm-gifting')
      if (confirmGiftingBtn) {
        confirmGiftingBtn.addEventListener('click', () => {
          const giftMessage = document.getElementById('gift-message')
          const giftBox = document.querySelector('.gift-box-checkbox:checked')
          
          if (!giftMessage) {
            console.warn('[GiftBox Debug] gift-message element not found');
            return;
          }

          if (giftMessage) {
            document.getElementById('selected-gift-message').value = giftMessage.value
          } else {
            document.getElementById('selected-gift-message').value = ''
          }

        if (giftBox) {
          giftBoxPrice.style.display = 'block'
          selectedGiftBox.style.display = 'block'
        } else {
          giftBoxPrice.style.display = 'none'
          selectedGiftBox.style.display = 'none'
        }

        if (giftMessage || giftBox) {
          document.getElementById('selected-gifting-options').style.display =
            'block'
          giftButton.style.display = 'none'
          this.closeDrawer()
          // Enable hidden inputs so they are submitted with the product-form
          this.enableGiftInputs()
          // Ensure hidden inputs reflect the currently checked gift
          this.primeGiftDefaults()
        }

        /**
         * Update the add to cart button with the updated price.
         * - Uses `setTimeout` to ensure that the other event listener in
         *   `gift-box-add-to-cart.js` has already fired.
         * - Future refactor could move the confirm gifting event listener and the
         *   code that disables/enables inputs into this file.
         */
        setTimeout(() => {
          this.updateAddToCartButton()
        }, 100)
        })
      } else {
        console.warn('[GiftBox Debug] confirm-gifting button not found');
      }

      const editGiftingBtn = document.getElementById('edit-gifting-options')
      if (editGiftingBtn) {
        editGiftingBtn.addEventListener('click', () => {
          this.openDrawer()
        })
      } else {
        console.warn('[GiftBox Debug] edit-gifting-options button not found');
      }

      // Remove selected Gifting options and set all the related properties disable
      const removeGiftingBtn = document.getElementById('remove-gifting-options')
      if (removeGiftingBtn) {
        removeGiftingBtn.addEventListener('click', () => {
          const properties = document.querySelectorAll('.gifting-property')
          const giftMessage = document.getElementById('selected-gift-message')

          document.getElementById('gift-box-price').style.display = 'none'
          document.getElementById('selected-gift-box').style.display = 'none'
          document.getElementById('selected-gifting-options').style.display =
            'none'
          document.querySelector('.perfect-gift-btn').style.display = 'block'

          this.querySelector('input[name="gift-box"]').checked = false;
          this.querySelector('#gift-message').value = ''
          this.querySelector('#textarea_feedback').innerHTML = '0/100'
          giftMessage.value = ''
          giftMessage.setAttribute('disabled', 'disabled')

          properties.forEach(property => {
            property.setAttribute('disabled', 'disabled')
          })

          setTimeout(() => {
            this.updateAddToCartButton()
          }, 100)
        })
      } else {
        console.warn('[GiftBox Debug] remove-gifting-options button not found');
      }
    }

    openDrawer() {
      const drawerOverlay = this.querySelector('#GiftingDrawer-Overlay')
      const giftDrawer = this.querySelector('#gifting-drawer')

      document.body.classList.add('overflow-hidden--drawer-open')
      document.documentElement.classList.add('overflow-hidden--drawer-open')
      giftDrawer.classList.add('open', 'animate')
      drawerOverlay.classList.add('active')
    }

    closeDrawer() {
      const drawerOverlay = this.querySelector('#GiftingDrawer-Overlay')
      const giftDrawer = this.querySelector('#gifting-drawer')

      document.body.classList.remove('overflow-hidden--drawer-open')
      document.documentElement.classList.remove('overflow-hidden--drawer-open')
      giftDrawer.classList.remove('open')
      drawerOverlay.classList.remove('active')
    }

    /**
     * Populate hidden inputs using the currently checked gift-box option.
     * Ensures properties like _giftProductHandle and ids are set even if user
     * didn't toggle the checkbox (default-checked).
     */
    primeGiftDefaults() {
      const checked = this.querySelector('.gift-box-checkbox:checked')
      if (!checked) return

      const giftBoxVariantIdField = document.querySelector('#gift-box-variant-id')
      const giftBoxGiftPid = document.querySelector('#gift__variantId')
      const giftBoxWithProduct = document.querySelector('#gift-box-for-product')
      const giftBoxProductHandle = document.querySelector('#gift-box-product-handle')
      const giftBoxProductHandleItem = document.querySelector('#gift-box-product-handle-item')
      const giftBoxPrice = document.querySelector('#gift-box-price')
      const selectedGiftBox = document.querySelector('#selected-gift-box')

      const mainTitleEl = document.querySelector('[data-product-title]') || document.querySelector('.product__title')
      const mainTitle = mainTitleEl ? mainTitleEl.textContent.trim() : checked.dataset.parentProductTitle || document.title

      if (giftBoxVariantIdField) giftBoxVariantIdField.value = checked.value
      if (giftBoxGiftPid) giftBoxGiftPid.value = checked.value
      if (giftBoxWithProduct) giftBoxWithProduct.value = mainTitle
      if (giftBoxProductHandle) giftBoxProductHandle.value = checked.dataset.productHandle
      if (giftBoxProductHandleItem) giftBoxProductHandleItem.value = checked.dataset.productHandle
      if (giftBoxPrice) giftBoxPrice.innerHTML = checked.dataset.productPrice
      if (selectedGiftBox) selectedGiftBox.innerHTML = checked.dataset.productTitle

      // Make sure these inputs submit
      this.enableGiftInputs()
    }

    updateAddToCartButton() {
      const section = this.dataset.originalSection || this.dataset.section
      const variantSelects = document.querySelector('variant-selects')
      const addToCartButton = document.querySelector(
        `#ProductSubmitButton-${section}`
      )
      const isAddToCartDisabled = addToCartButton.hasAttribute('disabled')

      if (variantSelects) {
        variantSelects.toggleAddButton(isAddToCartDisabled, '')
      }
    }

    checkTextLength(element) {
      const giftCounter = this.querySelector('#textarea_feedback')
      const textMax = 100
      const format = /[^\u0000-\u007f]/
      const hasSpecialCharacters = format.test(element.value)

      if (hasSpecialCharacters) {
        element.value = element.value.replace(new RegExp(format, 'gi'), '')
      }

      const textLength = element.value.length

      if (textLength > textMax) {
        element.value = element.value.substring(0, textMax)
      } else {
        giftCounter.innerHTML = textLength + '/' + textMax
      }
    }

    /**
     * Ensure all gift-box related hidden inputs are enabled before the product
     * form is submitted. Disabled inputs are ignored when the browser builds
     * FormData, which was why the note and box title were missing on the first
     * add-to-cart.
     */
    enableGiftInputs() {
      const idsToEnable = [
        'gift-box-variant-id',
        'gift__variantId',
        'gift-box-for-product',
        'selected-gift-message',
        'hasgiftboxId',
        'main__variantId',
        'main-product-groupId',
        'gift-box-groupId',
        'gift-box-addon',
        'gift-box-addon-type',
      ]

      idsToEnable.forEach(id => {
        const el = document.getElementById(id)
        if (el) {
          el.disabled = false
        }
      })

      // Ensure gift box product handle inputs are enabled so they submit
      const handleInputs = ['gift-box-product-handle', 'gift-box-product-handle-item']
      handleInputs.forEach(id => {
        const el = document.getElementById(id)
        if (el) {
          el.disabled = false
        }
      })
    }
  }

  customElements.define('gifting-drawer', GiftingDrawer)
})
